/**
 * LinkedInCallback.jsx
 *
 * Handles the redirect from the backend after LinkedIn OAuth.
 * The backend redirects to:
 *   /mentor-verification?linkedin_data=<base64_profile>
 *   /mentor-verification?linkedin_error=<reason>
 *
 * This component reads the URL params and stores the LinkedIn
 * profile data in sessionStorage so MentorVerification can read it,
 * then redirects there.
 */

import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function LinkedInCallback() {
  const [params]  = useSearchParams();
  const navigate  = useNavigate();

  useEffect(() => {
    const data  = params.get("linkedin_data");
    const error = params.get("linkedin_error");

    if (data) {
      try {
        const decoded = JSON.parse(atob(data));
        sessionStorage.setItem("linkedin_profile", JSON.stringify(decoded));
      } catch (_) {}
    }

    if (error) {
      sessionStorage.setItem("linkedin_error", error);
    }

    // Redirect to the verification form
    navigate("/mentor-verification", { replace: true });
  }, []);

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      minHeight: "100vh", fontFamily: "'DM Sans', sans-serif",
      flexDirection: "column", gap: 12, background: "#f0f4ff"
    }}>
      <div style={{
        width: 36, height: 36, border: "3px solid #e8eaf6",
        borderTopColor: "#5c6bc0", borderRadius: "50%",
        animation: "spin .6s linear infinite"
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <span style={{ color: "#888" }}>Completing LinkedIn verification…</span>
    </div>
  );
}